import React, {useEffect, useState} from 'react'
import {Container} from './styled'
import Select from "@material-ui/core/Select";
import OutlinedInput from "@material-ui/core/OutlinedInput";
import MenuItem from "@material-ui/core/MenuItem";
import { useSelector } from 'react-redux';

const IdTypeLog = props => {
  const { i18nState } = useSelector(state => state)
	const t = i18nState.translations[i18nState.lang]['Dashboard']
  const filters = [
    {id_type: 4, text: t?.department},
    {id_type: 5, text: t?.user},
    {id_type: null, text: t?.deselect},
  ]

  const {filter, setFilter} = props.filter
  const [id_type, setId_type] = useState(filter.id_type ? filter.id_type : '')

  useEffect(() => {
    setFilter({id_type})
  }, [id_type])

  return (
    <>
      <Container>
        <h5>{t?.filterPer}</h5>
        <Select
          value={id_type}
          displayEmpty
          onChange={({target}) => setId_type(target.value)}
          input={<OutlinedInput classes={{root: 'select-operator'}} />}
          classes={{selectMenu: 'select-operator_container'}}
          renderValue={selected => (
            selected === '' ? <em>{t?.selectFilter}</em> : <em>{filters.filter(x => x.id_type === selected)[0].text}</em>
          )}
          >          
          {
            filters.map(x => (
              <MenuItem value={x.id_type} key={x.id_type}>
                {x.text}
              </MenuItem>
            ))
          }
        </Select>
      </Container>
    </>
  )
}



export default IdTypeLog